// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MenuV5 = require("../Components/menu/MenuV5.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ContactAgentButton_agent_graphql = require("../../../__generated__/ContactAgentButton_agent_graphql.bs.js");

var convertFragment = ContactAgentButton_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ContactAgentButton_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ContactAgentButton_agent_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ContactAgentButton(props) {
  var __children = props.children;
  var __variant = props.variant;
  var __fullWidth = props.fullWidth;
  var __position = props.position;
  var onInitiateConversation = props.onInitiateConversation;
  var position = __position !== undefined ? __position : "bottom";
  var fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  var variant = __variant !== undefined ? __variant : "Primary";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : "Contact agent";
  var match = use(props.agent);
  var phone = match.phone;
  var emailAddress = match.emailAddress;
  var displayName = match.displayName;
  var disabled = onInitiateConversation === undefined;
  var button;
  switch (variant) {
    case "Primary" :
        button = JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              disabled: disabled,
              size: "small",
              className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
              children: Caml_option.some(children)
            });
        break;
    case "Secondary" :
        button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              disabled: disabled,
              size: "small",
              className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
              children: Caml_option.some(children)
            });
        break;
    case "Link" :
        button = JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
              disabled: disabled,
              size: "small",
              className: TailwindMerge.twMerge([fullWidth ? "w-full justify-center" : ""]),
              children: Caml_option.some(children)
            });
        break;
    
  }
  var tmp;
  tmp = onInitiateConversation !== undefined ? (
      onInitiateConversation.TAG === "Navigate" ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: onInitiateConversation._0,
              children: "Message on TAN"
            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: onInitiateConversation._0,
              children: "Message on TAN"
            })
    ) : null;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(MenuV5.Menu.make, {
                    button: button,
                    children: [
                      tmp,
                      phone !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "tel:" + phone,
                                      children: "Call"
                                    }),
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "sms:" + phone,
                                      children: "Send a text"
                                    })
                              ]
                            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              onAction: (function (prim) {
                                  
                                }),
                              isDisabled: true,
                              children: "No phone number for " + displayName
                            }),
                      emailAddress !== undefined ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              href: "mailto:" + Scalars.EmailAddress.toString(Caml_option.valFromOption(emailAddress)),
                              children: "Email"
                            }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                              onAction: (function (prim) {
                                  
                                }),
                              isDisabled: true,
                              children: "No email address for " + displayName
                            })
                    ],
                    placement: position === "top" ? "top start" : "bottom start"
                  }),
              className: "relative"
            });
}

var make = ContactAgentButton;

exports.Fragment = Fragment;
exports.make = make;
/* MenuV5 Not a pure module */
